import { Box } from "@mui/material";
import SelectFont from "./SelectFont";


export default function AttrsForText() {

    
    
    return (
       
            <Box
                sx={{
                   margin: "auto",
                   display: "flex",
                   flexWrap: "wrap",
                   p:1,
                   gap:2,
                   justifyContent: "center",
                   alignItems: 'center',
                //    border: "2px solid"
            }}>
                <SelectFont/>
               
                </Box>
    )
}